module.exports = __webpack_public_path__ + "img/expert-2.56150c9a.png";